import { useMemo } from "react";
import { EntityTypes } from "@vzbl/integrations";
import { useApplicationContext } from "src/hooks/useApplication";
import { useEntityContext } from "../useEntityContext";
import { TabbedWork } from "../components/TabbedWork";
import { Work, WorkComponent } from "../Work";
import { Insights } from "../Insights";
import { TimeMachine, TimeMachineComponent } from "../TimeMachine";
import { useWorkTabs } from "../components/worktabs";
import { EntityScreen } from "./components/layout/Screen2";
import { EntityTabs } from "./components/EntityTabs";
import { PullRequestOverview } from "./components/PullRequestOverview";

export const PullRequestEntity = () => {
  const context = useEntityContext();
  const entity = context.dataRef.current.entity;

  return (
    <EntityScreen>
      <EntityTabs entity={entity} tabs={usePullRequestTabs(entity)} />
    </EntityScreen>
  );
};

export function usePullRequestTabs(entity: any) {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  return [
    {
      key: "overview",
      id: "overview",
      label: "Overview",
      children: <PullRequestOverview entity={entity} />,
    },
    {
      key: "2",
      id: "2",
      label: "Work",
      children: (
        <>
          <TabbedWork
            items={useWorkTabs(orgId, entity.properties.uuid, [
              { entityTypes: EntityTypes.Issue },
              { entityTypes: EntityTypes.Sprint },
              { entityTypes: EntityTypes.Commit },
              {
                entityTypes: EntityTypes.PullRequestReviewComment,
                label: "Comments",
              },
              { entityTypes: EntityTypes.Branch, label: "Branches" },
              { entityTypes: EntityTypes.Release },
              { entityTypes: EntityTypes.Repository, label: "Repositories" },
              { entityTypes: EntityTypes.CicdPipeline, label: "Deployments" },
            ])}
          />
          <Work
            orgId={orgId}
            entityUuid={entity.properties.uuid}
            types={["Issue"]}
          >
            <WorkComponent title="Related Issues" />
          </Work>
        </>
      ),
    },
    {
      key: "analytics",
      label: "Analytics",
      children: <Insights entity={context.dataRef.current.entity} />,
    },
    {
      key: "5",
      id: "5",
      label: "History",
      children: (
        <TimeMachine>
          <TimeMachineComponent />
        </TimeMachine>
      ),
    },
  ];
}
